import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles } from 'lucide-react';
const bonos = [{
  num: 'B1',
  title: 'Fichas de Instrucción Visual',
  subtitle: 'para el Cuidador',
  desc: 'Láminas paso a paso para que el cuidador asista correctamente cuando el TO no está.',
  img: 'https://images.unsplash.com/photo-1576765608535-5f04d1e3f289?w=200&h=200&fit=crop&q=70&auto=format'
}, {
  num: 'B2',
  title: 'Banco de 40 Actividades',
  subtitle: 'Terapéuticas Domiciliarias',
  desc: '40 actividades clasificadas por objetivo, nivel y materiales disponibles en cualquier hogar.',
  img: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=200&h=200&fit=crop&q=70&auto=format'
}, {
  num: 'B3',
  title: 'Plantilla Historia Clínica',
  subtitle: 'Ocupacional Completa',
  desc: 'Sistema de documentación profesional desde el primer contacto hasta el alta.',
  img: 'https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?w=200&h=200&fit=crop&q=70&auto=format'
}, {
  num: 'B4',
  title: 'Guía Primera Entrevista',
  subtitle: 'Paciente y Familia',
  desc: 'Script completo para construir la alianza terapéutica desde el primer contacto.',
  img: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=200&h=200&fit=crop&q=70&auto=format'
}, {
  num: 'B5',
  title: 'Protocolo de Intervención',
  subtitle: 'en Crisis',
  desc: 'Guía de acción inmediata ante caídas, freezing, confusión aguda y emergencias.',
  img: 'https://images.unsplash.com/photo-1584515933487-779824d29309?w=200&h=200&fit=crop&q=70&auto=format'
}, {
  num: 'B6',
  title: 'Glosario Clínico',
  subtitle: 'Abordaje Neurodegenerativo',
  desc: 'Términos, escalas y marcos teóricos para hablar con autoridad dentro del equipo.',
  img: 'https://images.unsplash.com/photo-1532012197267-da84d127e765?w=200&h=200&fit=crop&q=70&auto=format'
}];
export const Bonos = () => {
  return <section className="py-12 md:py-20 bg-navy text-white" data-id="element-22">
      <div className="max-w-5xl mx-auto px-4" data-id="element-23">
        <div className="text-center mb-8 md:mb-12" data-id="element-24">
          <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-gold rounded-xl md:rounded-2xl mb-3 md:mb-6 shadow-[0_0_30px_rgba(212,162,76,0.3)]" data-id="element-25">
            <Gift className="w-6 h-6 md:w-8 md:h-8 text-navy" data-id="element-26" />
          </div>
          <h2 className="text-[11px] md:text-sm font-bold text-gold tracking-widest uppercase mb-1 md:mb-2" data-id="element-27">
            INCLUIDOS GRATIS
          </h2>
          <h3 className="text-2xl md:text-4xl font-extrabold mb-2 md:mb-4" data-id="element-28">
            6 Bonos Clínicos
          </h3>
          <p className="text-sm md:text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-29">
            Sin costo extra — incluidos en todas las ofertas
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-2.5 md:gap-3 mb-8 md:mb-12" data-id="element-30">
          {bonos.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="flex items-center gap-3 md:gap-4 bg-navy-light/60 border border-white/10 rounded-xl p-2.5 md:p-3 hover:border-gold/40 hover:bg-navy-light hover:translate-x-1 transition-all group relative overflow-hidden" data-id="element-31">
              {/* Thumbnail */}
              <div className="relative flex-shrink-0 w-16 h-16 md:w-20 md:h-20 rounded-lg overflow-hidden border border-white/10" data-id="element-32">
                <img src={bono.img} alt={`${bono.title} ${bono.subtitle}`} loading="lazy" decoding="async" width={200} height={200} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-33" />
                <div className="absolute inset-0 bg-gradient-to-tr from-navy/40 to-transparent" data-id="element-34"></div>
              </div>

              {/* Content */}
              <div className="flex-grow min-w-0" data-id="element-35">
                <div className="flex items-center gap-1.5 mb-1" data-id="element-36">
                  <div className="bg-gold text-navy font-black px-1.5 py-0.5 rounded text-[9px] md:text-[10px]" data-id="element-37">
                    {bono.num}
                  </div>
                  <div className="bg-teal/20 text-teal-light font-bold px-1.5 py-0.5 rounded text-[9px] md:text-[10px] flex items-center gap-0.5" data-id="element-38">
                    <Sparkles className="w-2.5 h-2.5" data-id="element-39" /> GRATIS
                  </div>
                </div>
                <h4 className="text-sm md:text-base font-bold text-white leading-tight" data-id="element-40">
                  {bono.title}
                </h4>
                <p className="text-gold-light text-[11px] md:text-xs font-medium mb-0.5" data-id="element-41">
                  {bono.subtitle}
                </p>
                <p className="text-gray-400 text-[10px] md:text-xs leading-snug line-clamp-2" data-id="element-42">
                  {bono.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-43">
          <div className="inline-block bg-gradient-to-r from-gold/20 via-gold/10 to-gold/20 border-2 border-gold/30 rounded-full px-5 md:px-8 py-3 md:py-4" data-id="element-44">
            <span className="text-sm md:text-2xl font-bold" data-id="element-45">
              VALOR TOTAL:{' '}
              <span className="line-through text-gray-500 mr-1 md:mr-2" data-id="element-46">
                $84.000
              </span>
              <span className="text-gold" data-id="element-47">— GRATIS</span>
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
};